'use strict';

const removeNonNumericCharacters = value => value.replace(/\D/g, '');
module.exports = removeNonNumericCharacters;
